import { useState, useEffect } from 'react';

// Contagem regressiva até a data de encerramento
    function Countdown({ targetDate }) {

        const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
        useEffect(() => {
            const handleResize = () => setIsMobile(window.innerWidth <= 768);
            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }, []);
        // Função para calcular o tempo restante
        const calculateTimeLeft = () => {
            const difference = +new Date(targetDate) - +new Date();
            let timeLeft = {};

            if (difference > 0) {
                timeLeft = {
                    dias: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    horas: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutos: Math.floor((difference / 1000 / 60) % 60),
                    segundos: Math.floor((difference / 1000) % 60),
                };
            }
            return timeLeft;
        };

        const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

        useEffect(() => {
            // Atualiza o contador a cada 1 segundo (1000ms)
            const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
            }, 1000);

            // Limpa o intervalo quando o componente for desmontado
            return () => clearInterval(timer);
        }, [targetDate]);

        // Formata os números para sempre exibirem 2 dígitos (ex: 05 ao invés de 5)
        const formatNumber = (number) => {
            return String(number || 0).padStart(2, '0');
        };

        const timerComponents = [];

        // Verifica se ainda existe tempo restante
        if (Object.keys(timeLeft).length > 0) {
            return (
            <div style={isMobile ? styles.containerMobile : styles.container}>
                <div style={isMobile ? styles.boxMobile : styles.box}>
                <span style={isMobile ? styles.numberMobile : styles.number}>{formatNumber(timeLeft.dias)}</span>
                <span style={isMobile ? styles.labelMobile : styles.label}>Dias</span>
                </div>
                <span style={styles.colon}>:</span>
                <div style={isMobile ? styles.boxMobile : styles.box}>
                <span style={isMobile ? styles.numberMobile : styles.number}>{formatNumber(timeLeft.horas)}</span>
                <span style={isMobile ? styles.labelMobile : styles.label}>Horas</span>
                </div>
                <span style={styles.colon}>:</span>
                <div style={isMobile ? styles.boxMobile : styles.box}>
                <span style={isMobile ? styles.numberMobile : styles.number}>{formatNumber(timeLeft.minutos)}</span>
                <span style={isMobile ? styles.labelMobile : styles.label}>Minutos</span>
                </div>
                <span style={styles.colon}>:</span>
                <div style={isMobile ? styles.boxMobile : styles.box}>
                <span style={isMobile ? styles.numberMobile : styles.number}>{formatNumber(timeLeft.segundos)}</span>
                <span style={isMobile ? styles.labelMobile : styles.label}>Segundos</span>
                </div>
            </div>
            );
        }

        return null; // Retorna null quando o tempo acabou
    };

    // Estilização simples embutida
    const styles = {
        container: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'sans-serif',
            gap: '10px',
        },
        containerMobile: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'sans-serif',
            gap: '5px',
        },
        box: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '10px 15px',
            backgroundColor: '#000000',
            color: '#ffffff',
            borderRadius: '8px',
            minWidth: '60px',
        },
        boxMobile: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '3px 7px',
            backgroundColor: '#000000',
            color: '#ffffff',
            borderRadius: '8px',
            minWidth: '40px',
        },
        number: {
            fontSize: '2rem',
            fontWeight: 'bold',
        },
        numberMobile: {
            fontSize: '1.2rem',
            fontWeight: 'bold',
        },
        label: {
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            color: '#d8dce2',
        },
        labelMobile: {
            fontSize: '0.50rem',
            textTransform: 'uppercase',
            color: '#d8dce2',
        },
        colon: {
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#1e293b',
        },
        colonMobile: {
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: '#1e293b',
        },
        finished: {
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: '#ef4444',
        },
        finishedMobile: {
            fontSize: '1.2rem',
            fontWeight: 'bold',
            color: '#ef4444',
        },
    };

export default Countdown;